import {Component, OnInit, Type} from '@angular/core';
import {ConfigureBaseComponent} from '../configure-base/configure-base.component';
import {ConfigureWidgetAxisChartCurveComponent} from './configure-widget-axis-chart-curve/configure-widget-axis-chart-curve.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import * as lodash from 'lodash';
import {WidgetUtils} from '../widget-utils';
import {SelectOption, SelectOptions} from '../../../../../shared/interfaces/form';
import {WidgetChartComponent} from '../../widgets/widget-chart/widget-chart.component';
import {dialogOpen} from '../../../../../shared/store/dialog/dialog.actions';

@Component({
  selector: 'app-configure-widget-axis-chart',
  templateUrl: './configure-widget-axis-chart.component.html',
  styleUrls: ['./configure-widget-axis-chart.component.scss']
})
export class ConfigureWidgetAxisChartComponent extends ConfigureBaseComponent implements OnInit {

  public readonly widgetComponent: Type<WidgetChartComponent> = WidgetChartComponent;

  public readonly form: FormGroup = new FormGroup({
    useDashboardPeriod: new FormControl(true),
    period: new FormControl(null),
    compare: new FormControl(null),
    title: new FormControl('', [Validators.required]),
    curves: new FormControl([], [Validators.required]),
    groupingBy: new FormControl('day', [Validators.required]),
    sameAxis: new FormControl(false),
    dashboard: this.dashboardCtrl
  });

  public curves: Array<any> = [];

  public readonly groupingOptions: SelectOptions<any, any> = this.periodsS.getGrouping();

  ngOnInit(): void {
    super.ngOnInit();
  }

  public onAddCurve(): void {
    this._store.dispatch(dialogOpen({
      component: ConfigureWidgetAxisChartCurveComponent,
      config: {
        width: '750px',
        height: 'auto'
      },
      data: {
        mode: this.data.mode,
        widget: this.data.widget,
        dashboard: this.data.dashboard,
        curves: this.curves,
        form: this.form.value
      }
    }));
  }

  public onConfigureCurve(curve: any): void {
    this._store.dispatch(dialogOpen({
      component: ConfigureWidgetAxisChartCurveComponent,
      config: {
        width: '750px',
        height: 'auto'
      },
      data: {
        mode: this.data.mode,
        widget: this.data.widget,
        dashboard: this.data.dashboard,
        curves: this.curves,
        curve: curve,
        config: curve.config,
        form: this.form.value
      }
    }));
  }

  public onDeleteCurve(curve: any): void {
    this.curves.splice(this.curves.findIndex(cur => cur === curve), 1);
    this.form.get('curves').setValue(this.curves);
  }

  protected initForm() {
    super.initForm();
    this.initCurves();
  }

  private initCurves(): void {
    if (this.data.curves) {
      this.form.patchValue(this.data.form, { emitEvent: false });

      this.updateCurves();
      this.form.get('curves').setValue(this.curves);
    } else {
      this.createCurves();
      this.form.get('curves').setValue(this.curves, {emitEvent: false});
    }
  }

  private updateCurves(): void {
    for (const curve of this.data.curves) {
      curve.config = {
        area: curve.type === 'area',
        dimensions: [this.form.get('groupingBy').value],
        metrics: [curve.metric.payload.attributes.slug],
        filters: curve.filters,
        name: curve.name,
        type: curve.type === 'area' && 'line' || curve.type,
        params: curve.params || curve.config.params
      };
    }

    this.curves = this.data.curves;
  }

  private createCurves(): void {
    const curves: Array<any> = [];

    if (this.data.widget) {
      for (let i: number = 0; i < this.data.widget.config.data.length; i++) {
        curves.push({
          config: lodash.cloneDeep(this.data.widget.config.data[i]),
          filters: this.data.widget.config.data[i].filters,
          name: this.data.widget.config.data[i].name,
          dimensions: WidgetUtils.getFilterDimensions(this.data.widget.config.data[i].filters, this.dimensions),
          metric: this.metrics.find(metric => metric.payload.attributes.slug === this.data.widget.config.data[i].metrics[0]),
          type: this.data.widget.config.data[i].area && 'area' || this.data.widget.config.data[i].type
        });
      }
    }

    this.curves = curves;
  }

  protected override getConfig(): any {
    const data: Array<any> = [];

    for (const curve of this.form.get('curves').value) {
      data.push({
        area: curve.config.area,
        dimensions: [this.form.get('groupingBy').value],
        metrics: curve.config.metrics,
        filters: curve.config.filters,
        name: curve.config.name,
        type: curve.config.type,
        params: {
          filters: curve.dimensions,
          metrics: [curve.metric],
          dimensions: []
        }
      });
    }

    return {
      data: data,
      groupingBy: this.form.get('groupingBy').value,
      title: this.form.get('title').value,
      type: 'axis',
      useDashboardPeriod: this.form.get('useDashboardPeriod').value,
      sameAxis: this.form.get('sameAxis').value,
      period: this.form.get('period').value
    };
  }

  public groupingValueGetter(option: SelectOption<any, any>): string {
    return option.key;
  }

}
